<template>
  <div class="download">
    <div class="download_item">
      <div class="qrcode">
        <img src="../../assets/img/qr_code.png" alt="">
      </div>
      <div class="info mTop20">钉钉扫描二维码使用</div>
    </div>
  </div>
</template>
<script>

export default {
  data() {
    return {
      
    };
  },
  mounted: function() {
    this.$store.dispatch("first_nav_change", "5");
  },
  computed: {},
  methods: {
    
  }
};
</script>


// WEBPACK FOOTER //
// src/components/pages/download.vue